import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';
import PowerUserModel from 'src/model/powerUser.model';
import { INewPasswordValidation } from 'src/model/modules/dashboardview.model';
import EcheckPermissionModel from 'src/model/echeckPermission.model';

export interface IDashboardError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IDashboardError = {
  hasFailed: false,
  message: ''
};
const INITIAL_NEW_PASSWORD_VALIDATION = {
  valid: false,
  dirty: false,
  message: ''
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: IDashboardError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const menuOption = (
  state: IInitialState['dashboardView']['menuOption'] = INITIAL_STATE
    .dashboardView.menuOption || 'info',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_MENU_OPTION: {
      return payload;
    }
    default:
      return state;
  }
};

const powerUsers = (
  state: IInitialState['dashboardView']['powerUsers'] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: PowerUserModel[];
  }
) => {
  switch (type) {
    case types.POWER_USER_SEARCH_RESULTS: {
      return payload;
    }
    default:
      return state;
  }
};

const hasSucceed = (
  state: IInitialState['dashboardView']['hasSucceed'] = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.DASHBOARD_VIEW_SUCCEED: {
      return payload;
    }
    default:
      return state;
  }
};

const currentPassword = (
  state: IInitialState['dashboardView']['currentPassword'] = INITIAL_STATE
    .dashboardView.currentPassword || '',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_DASHBOARD_CURRENT_PASSWORD: {
      return payload;
    }
    default:
      return state;
  }
};

const newPassword = (
  state: IInitialState['dashboardView']['newPassword'] = INITIAL_STATE
    .dashboardView.newPassword || '',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_DASHBOARD_NEW_PASSWORD: {
      return payload;
    }
    default:
      return state;
  }
};

const newPasswordRepeat = (
  state: IInitialState['dashboardView']['newPasswordRepeat'] = INITIAL_STATE
    .dashboardView.newPasswordRepeat || '',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_DASHBOARD_NEW_PASSWORD_REPEAT: {
      return payload;
    }
    default:
      return state;
  }
};

const newPasswordValidation = (
  state: IInitialState['dashboardView']['newPasswordValidation'] = INITIAL_STATE
    .accountView.newPasswordValidation || INITIAL_NEW_PASSWORD_VALIDATION,
  {
    type,
    payload
  }: {
    type: string;
    payload: INewPasswordValidation;
  }
) => {
  switch (type) {
    case types.SET_DASHBOARD_NEW_PASSWORD_VALIDATION: {
      return payload;
    }
    default:
      return state;
  }
};

const echeckDisabledUsers = (
  state: IInitialState['dashboardView']['echeckDisabledUsers'] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: EcheckPermissionModel[];
  }
) => {
  switch (type) {
    case types.ECHECK_DISABLED_USER_SEARCH_RESULTS: {
      return payload;
    }
    default:
      return state;
  }
};

export default combineReducers({
  menuOption,
  isPending,
  error,
  powerUsers,
  hasSucceed,
  currentPassword,
  newPassword,
  newPasswordRepeat,
  newPasswordValidation,
  echeckDisabledUsers
});
